import React, {useCallback, useEffect, useState} from 'react';
import {initYoutube, playlistId, YOUTUBE_API_KEY} from "./cfg/youtube-cfg";

// const searchYoutube = require('youtube-api-v3-search');

interface YoutubeItem {
  etag: string;
  id: string;
  kind: string;
  snippet: {
    channelId: string;
    channelTitle: string;
    description: string;
    playlistId: string;
    position: number;
    publishedAt: string;
    resourceId: {
      kind: string;
      videoId: string;
    };
    thumbnails: any;
    title: string;
  }
}

interface YoutubeResponse {
  etag: string;
  items: YoutubeItem[];
  kind: string;
  prevPageToken?: string;
  nextPageToken?: string;
  pageInfo: {
    totalResults: number;
    resultsPerPage: number;
  };
}

function useLocalStorage(id: string): [ string | null, (newValue: string) => void ] {
  const [ value, setValue ] = useState(() => window.localStorage.getItem(id));
  return [ value, useCallback(newValue => { window.localStorage.setItem(id, newValue); setValue(newValue) }, [id]) ];
}

function App() {
  const [ lastId, setLastId ] = useLocalStorage('lastId');
  const [ videos, setVideos ] = useState<YoutubeItem[]>([]);

  useEffect(() => {
    async function search(pageToken?: string) {
      if (pageToken == null) {
        setVideos([]);

        await initYoutube();
      }

      const pageTokenStr = pageToken != null ? `&pageToken=${pageToken}` : '';

      const videosJSON = await fetch(`https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=${playlistId}&key=${YOUTUBE_API_KEY}${pageTokenStr}`);
      const videos: YoutubeResponse = await videosJSON.json();

      // const videos: gapi.client.youtube.PlaylistItemListResponse = await gapi.client.playlistItems.list({
      //   pageToken,
      //   playlistId: playlistId ?? undefined,
      //   maxResults: 50,
      //   part: 'snippet'
      // });

      const playlistItems = videos.items ?? [];

      // const videos: YoutubeResponse = await searchYoutube(YOUTUBE_API_KEY, {
      //   channelId: 'UCeBMccz-PDZf6OB4aV6a3eA',
      //   maxResults: 50,
      //   order: 'date',
      //   // type: 'video',
      //   pageToken
      // });

      setVideos(oldVideos => [ ...oldVideos, ...playlistItems ]);

      if (lastId == null || playlistItems.some(vid => vid.snippet.resourceId.videoId === lastId)) {
        // return ;
      } else if (videos.nextPageToken != null) {
        await search(videos.nextPageToken);
      }
    }

    void search();
  }, [lastId]);

  return (
      <>
        <input type="text" value={lastId || ''} onChange={evt => setLastId(evt.target.value)} />
        <ul>
          { videos.filter(vid => vid != null).map(vid =>
              <li>
                { vid.snippet.resourceId.videoId === lastId ? <span style={{ color: 'red' }}>LAST SEEN! </span> : '' }
                <a href={`https://www.youtube.com/watch?v=${vid.snippet.resourceId.videoId}`} onClick={() => setLastId(vid.snippet.resourceId.videoId)} target="_blank" rel="noopener noreferrer">
                  { vid.snippet?.title } - { vid.snippet?.publishedAt }
                </a>
              </li>) }
        </ul>
      </>
  );
}

export default App;
